<template>
    <div>   
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('xtgl')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('sysparam')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont" v-loading="loading">
            <div class="mylist">
                <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id"
                    border lazy :load="load" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}"
                    :default-expand-all="false" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                    <el-table-column prop="typeName" :label="$t('paramName')" width="600"></el-table-column>
                    <el-table-column prop="typeValue" :label="$t('paramValue')" width="300"></el-table-column>
                    <el-table-column prop="status" :label="$t('status')" width="200">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status==1" type="primary" size="mini">{{$t('qiyong')}}</el-tag>
                            <el-tag v-if="scope.row.status==0" type="primary" size="mini">{{$t('jinyong')}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" :label="$t('operator')">
                        <template slot-scope="scope">
                            <el-button size="small" v-if="scope.row.type != null" @click="openedit(scope.row)" type="primary" icon="el-icon-edit" circle plain style="margin-right:4px;"></el-button>
                            <!-- <el-popconfirm title="确定要删除吗？" @confirm="deleteperm(scope.row)">
                                <el-button size="small" type="warning" icon="el-icon-delete-solid" circle slot="reference" plain></el-button>
                            </el-popconfirm> -->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <pop-up :title="$t('editSys')" width="40%" :isshow="showeditperm" :haveconfirm="true" @close="getclose" @confirm="getconfirm">
            <div slot="box">
                <el-form ref="form" :model="editform" label-width="140px">
                    <div class="popitembox">
                        <div class="popitem">
                            <el-form-item :label="$t('paramValue')">
                                <el-input v-model="editform.typeValue" style="width:500px;"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('status')">
                                <el-radio-group v-model="editform.status">
                                <el-radio :label="1">{{$t('qiyong')}}</el-radio>
                                <el-radio :label="0">{{$t('jinyong')}}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
import apiurl from "@/api/sys"
import _api from "@/api/index"
export default {
    data(){
        return{
            loading:false,
            showeditperm:false,
            tableData: [],
            editform:{
                id: "",
                typeValue: null,
                status: null
            },
        }
    },
    created(){
        this.getList()
    },
    methods:{
        deleteperm(row){
            _api.delete(apiurl.parameter,row.id).then(res=>{
                this.$notify({
                    title: this.$t('success'),
                    message:this.$t('delSuccess'),
                    type: 'success'
                });
                this.getList()
            }).catch(err=>{
                this.$notify.error({
                    title: this.$t('error'),
                    message: err.data.message
                });
            })
        },
        getList(){
            this.tableData=[]
            this.loading=true
            _api.get(apiurl.parameter,{}).then(res=>{
                this.loading=false
                this.tableData=res.data
            })
        },
        openedit(row){
            this.editform.id=row.id
            this.editform.typeValue=row.typeValue
            this.editform.status=row.status
            this.showeditperm=true
        },
        getconfirm(){
            _api.put(apiurl.parameter,this.editform).then(res=>{
                this.$notify({
                    title:this.$t('success'),
                    message: this.$t('editSuccess'),
                    type: 'success'
                });
                this.getclose()
                this.getList()
            }).catch(err=>{
                this.$notify.error({
                    title: this.$t('error'),
                    message: err.data.message
                });
            })
        },
        getclose(){
            this.showeditperm=false
        },
    }
}
</script>
<style>
</style>